import React from 'react';
import { Box, Button, Card, CardContent, Grid, Slider, Stack, Typography } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';

type Props = { mixer?: any; loading?: boolean; onDriverChange: (drivercode: string, value: number) => void; onRecompute: () => void };

class SimulationMixerPanel extends React.PureComponent<Props> {
  renderDriver(d: any) {
    const value = Number(d.value ?? d.effectivevalue ?? 0);
    const min = Number(d.minvalue ?? Math.floor(value * 0.5));
    const max = Number(d.maxvalue ?? Math.ceil(value * 1.5 || 100));
    const step = Number(d.stepvalue ?? d.step ?? 1);
    const atLimit = value >= max || value <= min;
    return (
      <Grid size={{ xs: 12, md: 6 }} key={d.drivercode || d.code}>
        <Card elevation={1}><CardContent>
          <Stack spacing={1.5}>
            <Stack direction="row" justifyContent="space-between">
              <Box><Typography variant="subtitle2" sx={{ fontWeight: 800 }}>{d.drivername || d.name}</Typography><Typography variant="caption" color="text.secondary">{d.drivercode || d.code}</Typography></Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>{value}</Typography>
            </Stack>
            <Slider value={value} min={min} max={max} step={step} size="medium" onChangeCommitted={(_, v) => this.props.onDriverChange(d.drivercode || d.code, Number(v))} sx={{ height: 10, '& .MuiSlider-thumb': { width: 18, height: 18 }, '& .MuiSlider-rail': { borderRadius: 1 }, '& .MuiSlider-track': { borderRadius: 1 } }} />
            <Stack direction="row" justifyContent="space-between"><Typography variant="caption" color="text.secondary">Min {min}</Typography><Typography variant="caption" color={atLimit ? 'warning.main' : 'text.secondary'}>{atLimit ? 'At configured limit' : `Max ${max}`}</Typography></Stack>
          </Stack>
        </CardContent></Card>
      </Grid>
    );
  }

  render() {
    const drivers = this.props.mixer?.drivers || [];
    return <Stack spacing={2}><Button variant="contained" startIcon={<CalculateIcon />} onClick={this.props.onRecompute} disabled={this.props.loading}>Recompute Scenario</Button><Grid container spacing={2}>{drivers.map((d: any) => this.renderDriver(d))}</Grid></Stack>;
  }
}
export default SimulationMixerPanel;
